import script from "./ServiceItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceItem.vue?vue&type=script&setup=true&lang=js"

import "./ServiceItem.vue?vue&type=style&index=0&id=595cc40b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-595cc40b"]])

export default __exports__